export default __webpack_public_path__ + "static/media/COMODO.90cb1009.svg";